import { useLayoutEffect, useRef } from "react";
import useNavigatorOnLine from "../../../hooks/useNavigatorOnLine";
import { useSnackbar } from "notistack";

export default function NetworkStatusIndicator() {
  const isOnline = useNavigatorOnLine();

  const firstUpdate = useRef(true);

  const { enqueueSnackbar } = useSnackbar();

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    isOnline
      ? enqueueSnackbar(
          "Congratulations, you are online now. Refresh to start over",
          { variant: "success" }
        )
      : enqueueSnackbar(
          "Your internet is currently down. Check and try again",
          { variant: "error" }
        );
  }, [enqueueSnackbar, isOnline]);

  return null;
}
